import React, { useEffect, useState } from "react";
import { ITodaysProps } from "./index";
import "./Style.css";
import { getPrayerTimesState } from "../../Redux/GetState";
import { useSelector } from "react-redux";
import {
  addDays,
  addMinutes,
  formatTime,
  getPrayerTime,
  PrayerType,
} from "../Helpers";

export const DailyMobileView: React.FC<ITodaysProps> = (
  props: ITodaysProps
): JSX.Element => {
  const { prayerTimes } = useSelector(getPrayerTimesState);
  const [date, setDate] = useState(new Date());

  const [startFajar, setStartFajar] = useState(new Date());
  const [startZohar, setStartZohar] = useState(new Date());
  const [startAsar, setStartAsar] = useState(new Date());
  const [startMaghrib, setStartMaghrib] = useState(new Date());
  const [startIsha, setStartIsha] = useState(new Date());

  const [jumatFajar, setJumatFajar] = useState(new Date());
  const [jumatDhuhr, setJumatZohar] = useState(new Date());
  const [jumatAsar, setJumatAsar] = useState(new Date());
  const [jumatMaghrib, setJumatMaghrib] = useState(new Date());
  const [jumatIsha, setJumatIsha] = useState(new Date());
  const [sunrise, setSunrise] = useState(new Date());

  const [remainingTime, setRemainingTime] = useState("");
  const [nextPrayerName, setNextPrayerName] = useState("");

  const [highlightFajar, setHighlightFajar] = useState(false);
  const [highlightDhyhr, setHighlightDhyhr] = useState(false);
  const [highlightAsar, setHighlightAsar] = useState(false);
  const [highlightMaghrib, setHighlightMaghrib] = useState(false);
  const [highlightIsha, setHighlightIsha] = useState(false);

  const [showFajar, setShowFajar] = useState(true);
  const [showDhuhr, setShowDhuhr] = useState(true);
  const [showAsar, setShowAsar] = useState(true);
  const [showIsha, setShowIsha] = useState(true);

  const [Jumaah, setJumaah] = useState("");

  var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  function makeDate(now: Date): Date {
    const temp = new Date();
    return new Date(
      temp.getFullYear(),
      temp.getMonth(),
      temp.getDate(),
      now.getHours(),
      now.getMinutes(),
      now.getSeconds()
    );
  }

  function blink(prayer: PrayerType) {
    if (prayer === PrayerType.Fajar) {
      if (showFajar) {
        setShowFajar(false);
      } else {
        setShowFajar(true);
      }
    } else if (prayer === PrayerType.Dhuhr) {
      if (showDhuhr) {
        setShowDhuhr(false);
      } else {
        setShowDhuhr(true);
      }
    } else if (prayer === PrayerType.Asr) {
      if (showAsar) {
        setShowAsar(false);
      } else {
        setShowAsar(true);
      }
    } else if (prayer === PrayerType.Isha) {
      if (showIsha) {
        setShowIsha(false);
      } else {
        setShowIsha(true);
      }
    }
  }

  function showAllTimes() {
    setShowFajar(true);
    setShowDhuhr(true);
    setShowAsar(true);
    setShowIsha(true);
  }

  function requireBlinking(
    todayPrayer: Date,
    tomorrowPrayer: Date,
    prayer: PrayerType
  ) {
    const delay = addMinutes(todayPrayer, 15);

    const t1 = makeDate(todayPrayer);
    const t2 = makeDate(tomorrowPrayer);

    if (t1.getTime() !== t2.getTime()) {
      if (
        date.getTime() > todayPrayer.getTime() &&
        date.getTime() < delay.getTime()
      ) {
        if (prayer === PrayerType.Fajar) {
          blink(PrayerType.Fajar);
        } else if (prayer === PrayerType.Dhuhr) {
          blink(PrayerType.Dhuhr);
        } else if (prayer === PrayerType.Asr) {
          blink(PrayerType.Asr);
        } else if (prayer === PrayerType.Isha) {
          blink(PrayerType.Isha);
        }
      } else {
        showAllTimes();
      }
    } else {
      showAllTimes();
    }
  }

  function setPrayerTimes() {
    const today = getPrayerTime(prayerTimes, props.dateTime.getDate());
    const tomorrow = getPrayerTime(prayerTimes, addDays(date, 1).getDate());

    if (!today || !tomorrow) {
      return;
    }

    setStartFajar(today.StartFajar);
    setJumatFajar(today.JumatFajar);

    setStartZohar(today.StartZohar);
    setJumatZohar(today.JumatZohar);

    setStartAsar(today.StartAsar);
    setJumatAsar(today.JumatAsar);

    setStartMaghrib(today.StartMaghrib);
    setJumatMaghrib(today.JumatMaghrib);

    setStartIsha(today.StartIsha);
    setJumatIsha(today.JumatIsha);

    setSunrise(today.Sunrise);

    let JumaahTimes = "";
    if (today.Jumaah1 !== undefined) {
      JumaahTimes += formatTime(today.Jumaah1);
    }
    if (today.Jumaah2 !== undefined) {
      JumaahTimes += "," + formatTime(today.Jumaah2);
    }
    if (today.Jumaah3 !== undefined) {
      JumaahTimes += "," + formatTime(today.Jumaah3);
    }

    setJumaah(JumaahTimes);

    const time = date.getTime();

    if (time < today.JumatFajar.getTime()) {
      timeRemaining(date, today.JumatFajar, PrayerType.Fajar);
    }

    if (
      time > today.JumatFajar.getTime() &&
      time < today.JumatZohar.getTime()
    ) {
      timeRemaining(date, today.JumatZohar, PrayerType.Dhuhr);
    }

    if (time > today.JumatZohar.getTime() && time < today.JumatAsar.getTime()) {
      timeRemaining(date, today.JumatAsar, PrayerType.Asr);
    }

    if (
      time > today.JumatAsar.getTime() &&
      time < today.StartMaghrib.getTime() &&
      today.IsRamadanDay === true
    ) {
      timeRemaining(date, today.StartMaghrib, PrayerType.Maghrib);
    } else if (
      time > today.JumatAsar.getTime() &&
      time < today.JumatMaghrib.getTime()
    ) {
      timeRemaining(date, today.JumatMaghrib, PrayerType.Maghrib);
    }

    if (
      time > today.JumatMaghrib.getTime() &&
      time < today.JumatIsha.getTime()
    ) {
      timeRemaining(date, today.JumatIsha, PrayerType.Isha);
    }

    if (
      time > today.JumatIsha.getTime() &&
      time < tomorrow.JumatFajar.getTime()
    ) {
      timeRemaining(date, tomorrow.JumatFajar, PrayerType.tomorrowFajar);
    }

    if (time > today.JumatFajar.getTime()) {
      setStartFajar(tomorrow.StartFajar);
      setJumatFajar(tomorrow.JumatFajar);
      requireBlinking(today.JumatFajar, tomorrow.JumatFajar, PrayerType.Fajar);
    }

    if (time > today.JumatZohar.getTime()) {
      setStartZohar(tomorrow.StartZohar);
      setJumatZohar(tomorrow.JumatZohar);
      requireBlinking(today.JumatZohar, tomorrow.JumatZohar, PrayerType.Dhuhr);
    }

    if (time > today.JumatAsar.getTime()) {
      setStartAsar(tomorrow.StartAsar);
      setJumatAsar(tomorrow.JumatAsar);
      requireBlinking(today.JumatAsar, tomorrow.JumatAsar, PrayerType.Asr);
    }

    if (time > today.JumatMaghrib.getTime()) {
      setStartMaghrib(tomorrow.StartMaghrib);
      setJumatMaghrib(tomorrow.JumatMaghrib);
      setSunrise(tomorrow.Sunrise);
    }
    if (time > today.JumatIsha.getTime()) {
      setStartIsha(tomorrow.StartIsha);
      setJumatIsha(tomorrow.JumatIsha);
      requireBlinking(today.JumatIsha, tomorrow.JumatIsha, PrayerType.Isha);
    }

    var day = days[date.getDay()];

    if (day === "Friday" && typeof today.Jumaah1 !== "undefined") {
      if (
        time > today.JumatFajar.getTime() &&
        time < today.JumatAsar.getTime() &&
        time < today.Jumaah1.getTime()
      ) {
        timeRemaining(date, today.Jumaah1, PrayerType.JummahOne);
        setJumatZohar(today.Jumaah1);
      }
    }

    if (
      day === "Friday" &&
      typeof today.Jumaah2 !== "undefined" &&
      typeof today.Jumaah1 !== "undefined"
    ) {
      if (
        time > today.JumatFajar.getTime() &&
        time < today.JumatAsar.getTime() &&
        time > today.Jumaah1.getTime() &&
        time < today.Jumaah2.getTime()
      ) {
        timeRemaining(date, today.Jumaah2, PrayerType.JummahTwo);
        setJumatZohar(today.Jumaah2);
      }
    }

    if (
      day === "Friday" &&
      typeof today.Jumaah2 !== "undefined" &&
      typeof today.Jumaah3 !== "undefined"
    ) {
      if (
        time > today.JumatFajar.getTime() &&
        time < today.JumatAsar.getTime() &&
        time > today.Jumaah2.getTime() &&
        time < today.Jumaah3.getTime()
      ) {
        timeRemaining(date, today.Jumaah3, PrayerType.JummahThree);
        setJumatZohar(today.Jumaah3);
      }
    }
  }

  function refresh() {
    setDate(props.dateTime);
    setPrayerTimes();
  }

  function highlight(prayer: PrayerType) {
    setHighlightFajar(false);
    setHighlightDhyhr(false);
    setHighlightAsar(false);
    setHighlightMaghrib(false);
    setHighlightIsha(false);

    if (prayer === PrayerType.Fajar) {
      setHighlightFajar(true);
    } else if (prayer === PrayerType.Dhuhr) {
      setHighlightDhyhr(true);
    } else if (prayer === PrayerType.Asr) {
      setHighlightAsar(true);
    } else if (prayer === PrayerType.Maghrib) {
      setHighlightMaghrib(true);
    } else if (prayer === PrayerType.Isha) {
      setHighlightIsha(true);
    } else if (prayer === PrayerType.tomorrowFajar) {
      setHighlightFajar(true);
    }
  }

  function timeRemaining(now: Date, nextPrayer: Date, prayerName: PrayerType) {
    now = new Date(now);
    nextPrayer = new Date(nextPrayer);

    var msec = nextPrayer.getTime() - now.getTime();
    var hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    var mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    var ss = Math.floor(msec / 1000);
    msec -= ss * 1000;

    var remainingTime;

    if (hh > 0) remainingTime = hh + "h " + mm + "min";
    else if (mm === 0) {
      remainingTime = ss + " sec";
    } else {
      remainingTime = mm + 1 + " min";
    }

    setRemainingTime(remainingTime);
    setNextPrayerName(prayerName + " prayer in");
    highlight(prayerName);
  }

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateTime]);

  function isHighlighted(prayer: boolean): React.CSSProperties {
    if (prayer) {
      return highlightPrayer;
    } else {
      return borderOnly;
    }
  }

  const dt1 = new Date().toLocaleDateString("en-GB");

  const highlightPrayer = {
    borderRadius: "25px",
    backgroundColor: "blue",
    padding: "20px",
    width: "100%",
    height: "100%",
    color: "white",
  };

  const borderOnly = {
    borderRadius: "25px",
    border: "1px solid black",
    padding: "20px",
    borderColor: "blue",
  };

  return (
    <>
      <div
        className="container"
        style={{
          alignItems: "center",
          textAlign: "center",
          verticalAlign: "middle",
          color: "Blue",
          fontSize: "10vw",
          fontWeight: "bold",
          backgroundColor: "white",
          padding: 50,
        }}
      >
        Prayer Times
      </div>
      <>
        <div
          className="container"
          style={{
            alignItems: "center",
            textAlign: "center",
            verticalAlign: "middle",
            color: "Blue",
            fontSize: "4.5vw",
            fontWeight: "bold",
            backgroundColor: "white",
          }}
        >
          <div className="col">
            <div style={isHighlighted(highlightFajar)}>
              Prayer in <br />
              <div style={{ fontSize: "9vh", fontWeight: "bold" }}>
                {showFajar ? remainingTime : <></>}{" "}
              </div>
            </div>
          </div>
          <br />
          <div className="col">
            <div style={isHighlighted(highlightFajar)}>
              Fajr <br />
              <div style={{ fontSize: "11vh", fontWeight: "bold" }}>
                {showFajar ? formatTime(jumatFajar) : <></>}{" "}
              </div>
              <div style={{ fontSize: "5vh" }}>{formatTime(startFajar)}</div>
            </div>
          </div>
          <br />
          <div className="col">
            <div style={isHighlighted(highlightFajar)}>
              Sunrise <br />
              <div style={{ fontSize: "11vh", fontWeight: "bold" }}>
                {showFajar ? formatTime(sunrise) : <></>}
              </div>
            </div>
          </div>
          <br />
          <div className="col">
            <div style={isHighlighted(highlightDhyhr)}>
              Zuhar <br />
              <div style={{ fontSize: "11vh", fontWeight: "bold" }}>
                {showDhuhr ? formatTime(jumatDhuhr) : <></>}{" "}
              </div>
              <div style={{ fontSize: "5vh" }}>{formatTime(startZohar)}</div>
            </div>
          </div>
          <br />
          <div className="col">
            <div style={isHighlighted(highlightAsar)}>
              Asar <br />
              <div style={{ fontSize: "11vh", fontWeight: "bold" }}>
                {showAsar ? formatTime(jumatAsar) : <></>}{" "}
              </div>
              <div style={{ fontSize: "5vh" }}>{formatTime(startAsar)}</div>
            </div>
          </div>
          <br />
          <div className="col">
            <div style={isHighlighted(highlightMaghrib)}>
              Maghrib <br />
              <div style={{ fontSize: "11vh", fontWeight: "bold" }}>
                {formatTime(jumatMaghrib)}
              </div>
              <div style={{ fontSize: "5vh" }}>{formatTime(startMaghrib)}</div>
            </div>
          </div>
          <br />
          <div className="col">
            <div style={isHighlighted(highlightIsha)}>
              Isha <br />
              <div style={{ fontSize: "11vh", fontWeight: "bold" }}>
                {showIsha ? formatTime(jumatIsha) : <></>}{" "}
              </div>
              <div style={{ fontSize: "5vh" }}>{formatTime(startIsha)}</div>
            </div>
          </div>
          <br />
        </div>
      </>
    </>
  );
};
